import api from "@/api";

const namespaced = true

const state = {
  cycleTimeUtilizationData: null,
  routes: [],
  bargeSizes: []

}

const getters = {
  cycleTimeUtilizationData: (state) => state.cycleTimeUtilizationData,
  routes: (state) => state.routes,
  bargeSizes: (state) => state.bargeSizes
}

const mutations = {
  SET_CYCLE_TIME_UTILIZATION_DATA: (state, payload) => {
    state.cycleTimeUtilizationData = payload
  },
  SET_ROUTES: (state, payload) => {
    state.routes = payload
  },
  SET_BARGE_SIZES: (state, payload) => {
    state.bargeSizes = payload
  }
}

const actions = {
  async fetchCycleTimeUtilization({ commit }, payload) {
    try {
      const { data } = await api.getCycleTimeUtilization(payload)

      if (data.error) {
        commit('SET_CYCLE_TIME_UTILIZATION_DATA', null)
        return
      }

      commit('SET_CYCLE_TIME_UTILIZATION_DATA', data)
    } catch (err) {
      throw err
    }
  },
  async fetchRoutes({ commit }) {
    try {
      const { data } = await api.getCycleTimeUtilRoutes()

      if (data.error) {
        commit('SET_ROUTES', [])
        return
      }

      commit('SET_ROUTES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchBargeSizes({ commit }) {
    try {
      const { data } = await api.getCycleTimeUtilBargeSizes()

      if (data.error) {
        commit('SET_BARGE_SIZES', [])
        return
      }

      commit('SET_BARGE_SIZES', data)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }